import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { E2eFmeFlagOverrideMap } from '@shared/interfaces/e2e-fme-flag-override.interface';
import { RestBuilder } from '../helpers/rest.builder';

interface IE2eFmeFlagOverridesResponse {
  flags: E2eFmeFlagOverrideMap;
}

@Injectable({
  providedIn: 'root',
})
export class E2eFmeFlagOverridesApi {
  private restBuilder: RestBuilder;

  constructor(private httpClient: HttpClient) {
    this.restBuilder = new RestBuilder();
  }

  public getForCurrentUser(tenantId?: string): Observable<IE2eFmeFlagOverridesResponse> {
    const url: string = this.restBuilder.create().e2e().e2eFmeFlagOverrides().getApiUrl();
    const params: HttpParams = tenantId ? new HttpParams().set('tenantId', tenantId) : new HttpParams();
    return this.httpClient.get<IE2eFmeFlagOverridesResponse>(url, { params });
  }
}
